import { defineComponent as _defineComponent } from 'vue'
import {
  TUITranslateService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  TUIChatService,
} from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import wordsIconLight from "../../../../assets/icon/words-light.svg";
import wordsIconDark from "../../../../assets/icon/words-dark.svg";
import { wordsList } from "../../utils/wordsList";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";
import { isPC, isUniFrameWork } from "../../../../utils/env";
import TUIChatConfig from "../../config";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["onDialogPopupShowOrHide"],
  setup(__props, { emit: emits }) {

const wordsIcon =
  TUIChatConfig.getTheme() === "dark" ? wordsIconDark : wordsIconLight;

const currentConversation = ref<IConversationModel>();
const container = ref();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const selectWord = (item: any) => {
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID ||
      currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload: {
      text: TUITranslateService.t(`Words.${item.value}`),
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  TUIChatService.sendTextMessage(options);
  // close dialog after submit evaluate
  container?.value?.toggleDialogDisplay(false);
};

const closeDialog = () => {
  container?.value?.toggleDialogDisplay(false);
};

const onDialogShow = () => {
  emits("onDialogPopupShowOrHide", true);
};

const onDialogClose = () => {
  emits("onDialogPopupShowOrHide", false);
};

return { __sfc: true,wordsIcon, emits, currentConversation, container, selectWord, closeDialog, onDialogShow, onDialogClose, TUITranslateService, ToolbarItemContainer, wordsList, isPC, isUniFrameWork }
}

})